import {useContext} from 'react';

import {UrlFlagsContext} from 'hsi/containers/Login/UrlFlagsProvider';

import {CCFlagsType} from 'hsi/types/cc-flags';

export default function useUrlFlags(): CCFlagsType {
    return useContext(UrlFlagsContext) as CCFlagsType; // TODO: Type URL flags so that they return a LDFLagSet
}
